/*@ngInject*/
const advancedFilterSplitterFilter = function () {
    return function (items, before, after) {
        let splitterIndex;

        if (items) {
            splitterIndex = _.findIndex(items, function (item) {
                return item.uiType === 10;
            });
            if (before && !after && splitterIndex > -1) {
                return items.slice(0, splitterIndex);
            } else if (before && !after && splitterIndex === -1) {
                return items;
            } else if (!before && after && splitterIndex > -1) {
                return items.slice(splitterIndex, items.length);
            } else if (splitterIndex > -1) {
                return [items[splitterIndex]];
            }
        }
    };
};

angular.module('umCore')
    .filter('advancedFilterSplitterFilter', advancedFilterSplitterFilter);
